import React from "react"
import { Link } from "react-router-dom"
import type { ActiveAttempt } from "../../types"

/** Tempo restante em linguagem humana ("6h", "45 min", "expirado"). */
function humanRemaining(deadlineIso: string): string {
  const ms = new Date(deadlineIso).getTime() - Date.now()
  if (ms <= 0) return "expirado"
  const totalMin = Math.round(ms / 60_000)
  if (totalMin < 60) return `${totalMin} min`
  return `${Math.round(totalMin / 60)}h`
}

/**
 * Card fixo no topo do dashboard quando há simulado em andamento (decisão 3.4
 * do plano): nem popup nem redirect — mostra progresso + prazo e devolve o
 * controle ao usuário com o botão Continuar.
 */
export function ActiveAttemptBanner({ attempt }: { attempt: ActiveAttempt }) {
  const remaining = humanRemaining(attempt.deadline_at)
  const urgent = new Date(attempt.deadline_at).getTime() - Date.now() < 4 * 60 * 60 * 1000

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-gold-400 bg-gold-50/70 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <svg
          viewBox="0 0 24 24"
          className="mt-0.5 h-5 w-5 shrink-0 text-gold-600"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <path strokeLinecap="round" d="M12 7v5l3 3" />
        </svg>
        <div>
          <p className="text-sm font-semibold text-navy-900">Simulado em andamento — {attempt.prova_name}</p>
          <p className="text-xs text-navy-500">
            <span className="font-semibold tabular-nums">
              {attempt.answered_count} de {attempt.total_questions}
            </span>{" "}
            respondidas ·{" "}
            <span className={urgent ? "font-semibold text-red-600" : ""}>expira em {remaining}</span>
          </p>
        </div>
      </div>
      <Link
        to={`/simulado/${attempt.id}`}
        className="shrink-0 rounded-lg bg-gold-500 px-4 py-2 text-center text-sm font-bold text-navy-950 transition-colors hover:bg-gold-400"
      >
        Continuar
      </Link>
    </div>
  )
}
